import {
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_FIELD_NOT_MODIFIED_GUIDE_CONFIRM,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';

type ContractSetupConfirmedThatFieldCannotBeModified = boolean;

const initialState: ContractSetupConfirmedThatFieldCannotBeModified = false;

export default function reducer(
  state: ContractSetupConfirmedThatFieldCannotBeModified = initialState,
  action: ContractSetupAction
) {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
      return false;
    case CONTRACT_SETUP_FIELD_NOT_MODIFIED_GUIDE_CONFIRM:
      return true;
    default:
      return state;
  }
}
